module.exports = __webpack_public_path__ + "images/gds1.png?v=df396640eec4062da3a242c33adb762b";